const strings = {
  'getNewApp/header1': {
    en: 'The same',
    fr: 'La même appli',
  },
  'getNewApp/header2': {
    en: 'app you love-now with a new look.',
    fr: 'que vous aimez - maintenant avec un nouveau look.',
  },
  'getNewApp/text': {
    en: 'You’ll need to update to the latest version of the app in order to play the Tims NHL Hockey Challenge<sup>TM</sup>.',
    fr: 'Vous devez mettre à jour l’appli pour participer au Défi de hockey de la LNH de Tim Hortons.',
  },
  'getNewApp/googleLink': {
    en: 'https://play.google.com/store/apps/details?id=digital.rbi.timhortons&hl=en_CA&gl=CA&pli=1',
    fr: 'https://play.google.com/store/apps/details?id=digital.rbi.timhortons&hl=fr_CA&gl=CA&pli=1',
  },
  'getNewApp/appleLink': {
    en: 'https://apps.apple.com/ca/app/tim-hortons/id1143883086',
    fr: 'https://apps.apple.com/ca/app/tim-hortons/id1143883086?l=fr',
  },
  'getNewApp/timsLogo': {
    en: 'Tims_en.png',
    fr: 'Tims_fr.png',
  },
  'getNewApp/appleLogo': {
    en: 'Apple_en.png',
    fr: 'Apple_fr.png',
  },
  'getNewApp/googleLogo': {
    en: 'Google_en.png',
    fr: 'Google_fr.png',
  },
};

export default strings;
